import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
const MyBlog = ({ blogs, loading, error }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;
  const navigate = useNavigate();
  // Get current blogs for pagination
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate pagination numbers
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-red-500 py-8">Error: {error}</div>;
  }

  if (blogs.length === 0) {
    return (
      <>
        <div className="flex justify-end mb-6">
          <Link
            to="/blog-create"
            className="btn btn-info btn-md px-6 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-3"
            // className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-2"
          >
            <i className="fa-solid fa-plus"></i>
            Tạo mới Blog
          </Link>
        </div>
        <div className="text-center text-gray-500 py-8">
          Không tìm thấy blog nào. Hãy quay lại sau để xem bài viết mới!
        </div>
      </>
    );
  }

  const handleUpdateBlog = (blogId) => {
    navigate(`/blog-update/${blogId}`);
  };

  return (
    <>
      <div className="flex justify-end mb-6">
        <Link
          to="/blog-create"
          className="btn btn-info btn-md px-6 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-3"
          // className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center gap-2"
        >
          <i className="fa-solid fa-plus"></i>
          Tạo mới Blog
        </Link>
      </div>
      {currentBlogs.map((blog) => (
        <div class="col-xl-4 col-md-6" key={blog.id}>
          <div class="blog-item mb-2 wow fadeInUp" data-wow-delay="0.2s">
            <Link to={`/blog-detail/${blog.id}`} class="blog-img">
              <img
                src={blog.imageUrls[0] || ""}
                class="w-100"
                style={{ height: "400px", objectFit: "cover" }}
                alt={blog.name}
              />
            </Link>
            {blog.status === 1 ? (
              <span class="badge bg-success fs-13 fw-medium">Hoạt động</span>
            ) : (
              <span class="badge bg-primary fs-13 fw-medium">
                Chưa được duyệt
              </span>
            )}
            <div class="blog-info text-center">
              <div class="d-inline-flex align-items-center justify-content-center">
                <div class="d-inline-flex align-items-center border-end pe-3  mb-2">
                  <a class="d-flex align-items-center">
                    <span class="avatar avatar-sm me-2">
                      <img
                        src={blog.userImage || ""}
                        class="rounded-circle border border-white"
                        alt={blog.authorName || "User"}
                      />
                    </span>
                    <p>{blog.authorName || "User"}</p>
                  </a>
                </div>
                <p class="text-white mb-2">
                  <i class="isax isax-calendar-2 me-2"></i>
                  {new Date(blog.createdDate).toLocaleDateString()}
                </p>
              </div>
              <h5>
                <Link to={`/blog-detail/${blog.id}`}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: blog.name || "No description available.",
                    }}
                  />
                </Link>
              </h5>
            </div>
          </div>
          <div className="flex justify-center gap-3 mb-4">
            <button
              onClick={() => handleUpdateBlog(blog.id)}
              className="rounded-xl bg-yellow-400 py-1 text-white hover:bg-yellow-500 transition-colors duration-300 flex items-center justify-center gap-2 shadow-sm hover:shadow-md w-40"
            >
              <i className="fa-solid fa-pen-to-square"></i>
              Sửa
            </button>
          </div>
        </div>
      ))}

      <nav className="pagination-nav mb-4 mb-lg-0">
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Previous"
            >
              <span aria-hidden="true">
                <i className="fa-solid fa-chevron-left"></i>
              </span>
            </button>
          </li>
          {pageNumbers.map((number) => (
            <li
              key={number}
              className={`page-item ${currentPage === number ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => paginate(number)}>
                {number}
              </button>
            </li>
          ))}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Next"
            >
              <span aria-hidden="true">
                <i className="fa-solid fa-chevron-right"></i>
              </span>
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default MyBlog;
